import { useTranslation } from '@klaviyo-mkt/gatsby-components/hooks/useTranslation';

import type { TIconName } from '@klaviyo-mkt/gatsby-components/atoms/icon/types';
import type { IMoreCards } from '@klaviyo-mkt/gatsby-components/organisms/more-cards/types';

export const useMoreCardsData = () => {
  const { t } = useTranslation();

  const richTextCard3 = t('organisms_moreCards_card3_richText_template', {
    accessSupport: t('organisms_moreCards_card3_richText_accessSupport'),
    emailSupport: t('organisms_moreCards_card3_richText_emailSupport'),
    emailSupportAccountTypes: t('organisms_moreCards_card3_richText_emailSupportAccountTypes'),
    emailSupportAvailability: t('organisms_moreCards_card3_richText_emailSupportAvailability'),
    chatVirtualAssistance: t('organisms_moreCards_card3_richText_chatVirtualAssistance'),
    chatVirtualAssistanceAvailability: t('organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability'),
  });

  const moreCards = [
    {
      eyebrow: t('organisms_moreCards_card1_eyebrow'),
      icon: {
        iconName: t('organisms_moreCards_card1_icon_iconName') as TIconName,
      },
      richText: t('organisms_moreCards_card1_richText'),
      button: {
        text: t('organisms_moreCards_card1_button_label'),
        url: t('organisms_moreCards_card1_button_href'),
        openInNewTab: false,
      },
    },
    {
      eyebrow: t('organisms_moreCards_card2_eyebrow'),
      icon: {
        iconName: t('organisms_moreCards_card2_icon_iconName') as TIconName,
      },
      richText: t('organisms_moreCards_card2_richText'),
      button: {
        text: t('organisms_moreCards_card2_button_label'),
        url: t('organisms_moreCards_card2_button_href'),
        openInNewTab: false,
      },
    },
    {
      eyebrow: t('organisms_moreCards_card3_eyebrow'),
      icon: {
        iconName: t('organisms_moreCards_card3_icon_iconName') as TIconName,
      },
      richText: richTextCard3,
      button: {
        text: t('organisms_moreCards_card3_button_label'),
        url: t('organisms_moreCards_card3_button_href'),
        openInNewTab: false,
      },
    },
  ] satisfies IMoreCards['moreCards'];

  return moreCards;
};
